export default "__VITE_ASSET__DVLYQfIJ__"